import React from 'react';

/* ─── Field wrapper ─── */
export const FormField: React.FC<{
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  span?: 1 | 2 | 3;
}> = ({ label, required, error, children, span }) => (
  <div className={`form-field${span === 2 ? ' form-field--span-2' : span === 3 ? ' form-field--span-3' : ''}`}>
    <label className="form-field__label">
      {label}{required && <span className="form-field__req">*</span>}
    </label>
    {children}
    {error && <span className="form-field__error">{error}</span>}
  </div>
);

/* ─── Text input ─── */
export const FormInput: React.FC<React.InputHTMLAttributes<HTMLInputElement> & { hasError?: boolean }> = ({
  hasError, className, ...props
}) => (
  <input className={`form-input${hasError ? ' form-input--error' : ''}${className ? ` ${className}` : ''}`} {...props} />
);

/* ─── Select ─── */
export const FormSelect: React.FC<React.SelectHTMLAttributes<HTMLSelectElement> & { children: React.ReactNode }> = ({
  children, className, ...props
}) => (
  <select className={`form-input form-select${className ? ` ${className}` : ''}`} {...props}>{children}</select>
);

/* ─── Textarea ─── */
export const FormTextarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
  className, ...props
}) => (
  <textarea className={`form-textarea${className ? ` ${className}` : ''}`} {...props} />
);

/* ─── Toggle switch ─── */
export const FormToggle: React.FC<{
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}> = ({ label, checked, onChange }) => (
  <label className="form-toggle">
    <div
      className={`form-toggle__track${checked ? ' form-toggle__track--on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <div className="form-toggle__thumb" />
    </div>
    <span className="form-toggle__label">{label}</span>
  </label>
);

/* ─── Chip (selectable tag) ─── */
export const FormChip: React.FC<{
  label: string;
  selected: boolean;
  onClick: () => void;
}> = ({ label, selected, onClick }) => (
  <button
    type="button"
    className={`form-chip${selected ? ' form-chip--selected' : ''}`}
    onClick={onClick}
  >
    {label}
  </button>
);
